import { DataBean } from "../DataBean";

export class SalesOrderItemQuota extends DataBean {

    public async deleteSalesOrderItemQuota(idSalesOrderItemQuota: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSalesOrderItemQuota_Number", [idSalesOrderItemQuota]);
    }

    public async getSalesOrderItemQuota(idSalesOrderItemQuota: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.SalesOrderItemQuota_getSalesOrderItemQuota_Number", [idSalesOrderItemQuota]);
    }

    public async getSalesOrderItemQuotaCatalog(idSalesOrder: number, salesOrderDate: any, idSalesOrderItem: number, idAccount: number, regexStr: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getSalesOrderItemQuotaCatalog_Number_java.util.Date_Number_Number_String_Number_Number", [idSalesOrder, salesOrderDate, idSalesOrderItem, idAccount, regexStr, page, recordsPerPage]);
    }

    public async getSalesOrderItemAccountList(idSalesOrder: number, salesOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalesOrderItemAccountList_Number_java.util.Date", [idSalesOrder, salesOrderDate]);
    }

    public async addSalesOrderItemQuota(idSalesOrderItem: number, salesOrderDate: any, idAccount: number, idProduct: number, idMeasurementUnitCode: number, idCurrency: number, totalItemAmount: number, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.SalesOrderItemQuota_addSalesOrderItemQuota_Number_java.util.Date_Number_Number_Number_Number_Number_Number", [idSalesOrderItem, salesOrderDate, idAccount, idProduct, idMeasurementUnitCode, idCurrency, totalItemAmount, idEmployee]);
    }

}
